import React, { useState } from "react";
import Button from "../../components/Button";
import CardLayout from "../../components/CardLayout";
import Input from "../../components/Input";
import Select from "../../components/Select";

const selectOption = ["tron", "trust wallet", "mono wallet", "doge coin"];

const WithdrawFundsPage = () => {
  const [data, setData] = useState({
    receiverAddress: "tWtusXtlsySfdisSefyslfieur",
    receiver_wallet: "",
    amount: "",
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(data);
  };
  return (
    <div className="mono_withdrawfunds_page_wrapper">
      <CardLayout
        style={{ backgroundColor: "#fff" }}
        className="mono_withdrawfunds_form_card"
      >
        <div className="mono_section_title">
          <h2>Withdraw</h2>
        </div>
        <div className="mono_withdrawfunds_page_content">
          <form onSubmit={handleSubmit}>
            <div className="form_group">
              <Input
                label="Receiver Wallet Address"
                type="text"
                name="receiverAddress"
                placeholder="Enter receiver wallet address"
                value={data.receiverAddress}
                className="input_field"
                disabled={true}
              />
            </div>
            <div className="form_group">
              <Select
                label="Receiver Wallet"
                className="select_field"
                value={data.receiver_wallet}
                name="receiver_wallet"
                onChange={(e) =>
                  setData({ ...data, receiver_wallet: e.target.value })
                }
                options={selectOption}
              />
            </div>
            <div className="form_group">
              <Input
                label="Enter amount"
                type="text"
                name="amount"
                placeholder="Enter amount"
                onChange={(e) => setData({ ...data, amount: e.target.value })}
                className="input_field"
              />
            </div>
            <Button type="submit" className="submit_btn">
              withdraw
            </Button>
          </form>
        </div>
      </CardLayout>
    </div>
  );
};

export default WithdrawFundsPage;
